import React from "react";
import Footer from "../utilities/Footer";
import AppState from "../../util/AppState";
import { useTranslation } from "react-i18next";
import { languages } from "../../util/languages";
import { logFunctions as log } from "../../util/Logging";

function SelectLanguageScreen(props) {
  log.debug("+SelectLanguagesScreen(TRACE)");

  const { i18n, t } = useTranslation("translation");

  function routeToPreviousScreen() {
    log.debug("+SelectLanguageScreen_routeToPreviousScreen(TRACE)");
    log.info(
      "SelectLanguageScreen_routeToPreviousScreen() => previous screen name: %s",
      props.previousStateName
    );
    switch (props.previousStateName) {
      case AppState.ENTER_LOYALTY_CARD_SCREEN:
        props.transitionToEnterLoyaltyCardScreen();
        break;
      case AppState.ATTRACT_SCREEN:
        props.transitionToAttractScreen();
        break;
      case AppState.STAGING_SCREEN:
        props.transitionToStagingScreen();
        break;
      case AppState.NO_DEVICES_AVAILABLE_SCREEN:
        props.transitionToNoDevicesAvailableScreen();
        break;
      case AppState.DEVICE_ALREADY_TAKEN_SCREEN:
        props.transitionToDeviceAlreadyTakenScreen();
        break;
      case AppState.WEB_SOCKET_CONNECTION_ERROR_SCREEN:
        props.transitionToWebsocketConnectionErrorScreen();
        break;
      case AppState.WELCOME_SCREEN:
        props.transitionToWelcomeScreen();
        break;
      case AppState.SELECT_SITE_AND_WALL_ID_SCREEN:
        props.transitionToSelectIDScreen(props.sitesList);
        break;
      case AppState.ADMIN_SCREEN:
        props.transitionToAdminScreen();
        break;
      default:
        props.transitionToAttractScreen();
    }
    log.debug("-SelectLanguageScreen_routeToPreviousScreen(TRACE)");
  }

  const renderLanguageButtons = () => {
    log.debug("+SelectLanguageScreen_renderLanguageButtons(TRACE)");
    log.info(
      "SelectLanguageScreen_renderLanguageButtons() => The supported langauges are: %s",
      JSON.stringify(languages)
    );
    log.debug("-SelectLanguageScreen_renderLanguageButtons(TRACE)");
    return (
      <div className="selectLanguageColumns">
        {languages.map((language, index) => {
          if (
            !localStorage.getItem("SupportedLocales") ||
            localStorage
              .getItem("SupportedLocales")
              .includes(language.languageCode)
          ) {
            return (
              <div
                className="selectLanguageButtonItem"
                id={"languageButtonLabel" + index}
                key={index}
                onClick={() => {
                  i18n.changeLanguage(language.languageCode);
                  localStorage.setItem("kioskLanguage", language.languageCode);
                  log.info(
                    "SelectLanguageScreen_onClick() => Language changed to " +
                      localStorage.getItem("kioskLanguage")
                  );
                  routeToPreviousScreen();
                }}
              >
                <p>{language.languageText}</p>
              </div>
            );
          } else {
            return null;
          }
        })}
      </div>
    );
  };

  log.debug("-SelectLanguageScren(TRACE)");
  return (
    <div className="Screen">
      <div className="contentContainer">
        <div className="contentTitleTextBox" id="selectLanguageTextLabel">
          <h4>{t("Choose Your Language")}</h4>
        </div>
        <div className="languageButtonsContainer">
          {renderLanguageButtons()}
        </div>
      </div>

      <div className="footerContainer" id="Footer">
        <Footer
          transitionToPreviousScreen={() => routeToPreviousScreen()}
          state={AppState.SELECT_LANGUAGE_SCREEN}
        />
      </div>
    </div>
  );
}

export default SelectLanguageScreen;
